export async function initStageReport({
  token,
  userId,
  email,
  name,
  userType,
  reportId,
  themeName,
  totalPuzzles,
  stageToggles,
}) {
  const tokenStr = String(token ?? '').trim();
  const [sessionIdFromToken, organizationIdFromToken] = tokenStr.includes('&')
    ? tokenStr.split('&')
    : [null, null];
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/initStageReport`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      userId,
      email,
      name,
      user_type: userType,
      reportid: reportId,
      themeName,
      ...(totalPuzzles != null && Number.isFinite(Number(totalPuzzles))
        ? { total_puzzles: Number(totalPuzzles) }
        : {}),
      ...(stageToggles && typeof stageToggles === 'object' ? stageToggles : {}),
      ...(sessionIdFromToken ? { sessionId: String(sessionIdFromToken) } : {}),
      ...(organizationIdFromToken ? { organizationId: String(organizationIdFromToken) } : {}),
    }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok || !data.success) {
    throw new Error(data.message || 'Failed to initialize stage report');
  }
  return data;
}

export async function updateStageProgress({
  token,
  userId,
  sessionId: sessionIdParam,
  organizationId: organizationIdParam,
  dayNumber,
  points,
  timeSeconds,
  answer,
  allCorrect,
  email,
  name,
  status,
}) {
  const tokenStr = String(token ?? '').trim();
  const [sessionIdFromToken, organizationIdFromToken] = tokenStr.includes('&')
    ? tokenStr.split('&')
    : [null, null];
  const sessionId = sessionIdParam ?? sessionIdFromToken;
  const organizationId = organizationIdParam ?? organizationIdFromToken;

  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/updateStageProgress`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      userId,
      ...(sessionId ? { sessionId: String(sessionId) } : {}),
      ...(organizationId ? { organizationId: String(organizationId) } : {}),
      ...(dayNumber != null ? { dayNumber } : {}),
      points,
      timeSeconds,
      answer,
      allCorrect,
      email,
      name,
      ...(status != null ? { status } : {}),
    }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok || !data.success) {
    throw new Error(data.message || 'Failed to update stage progress');
  }
  return data;
}

export async function uploadStageAnswerImage({
  token,
  userId,
  sessionId,
  organizationId,
  stageNumber,
  file,
}) {
  const tokenStr = String(token ?? '').trim();
  const [sessionIdFromToken, organizationIdFromToken] = tokenStr.includes('&')
    ? tokenStr.split('&')
    : [null, null];
  const resolvedSessionId = sessionId ?? sessionIdFromToken;
  const resolvedOrganizationId = organizationId ?? organizationIdFromToken;

  const formData = new FormData();
  formData.append('image', file);
  formData.append('userId', String(userId ?? ''));
  formData.append('stageNumber', String(stageNumber ?? ''));
  if (resolvedSessionId) formData.append('sessionId', String(resolvedSessionId));
  if (resolvedOrganizationId) formData.append('organizationId', String(resolvedOrganizationId));

  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/uploadStageAnswerImage`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok || !data.success) {
    throw new Error(data.message || 'Failed to upload stage image');
  }
  return data;
}

export async function fetchGameStages({ token, userId, organizationId, sessionId }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/getGameStages`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ userId, organizationId, sessionId }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok || !data.success) {
    throw new Error(data.message || 'Failed to fetch game stages');
  }
  return data;
}

export async function updateStageFeedback({ token, userId, dayNumber, feedback, stageId }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/updateStageFeedback`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      userId,
      dayNumber,
      feedback,
      stageId,
    }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok || !data.success) {
    throw new Error(data.message || 'Failed to update stage feedback');
  }
  return data;
}
